import _ from "lodash";

export const poleEffortModuleTabsMixin = {
  props: {
    objectData: Object,

    poleType: {
      type: String,
      required: true
    },

    disabled: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      readOnly: this.disabled
    };
  },

  computed: {
    isElectrical() {
      return this.poleType === "ENERGY";
    },

    isTelecom() {
      return this.poleType === "TELECOM";
    }
  },

  methods: {
    getValueInObject(varName) {
      if (varName.includes("tp_pe_")) {
        return _.get(this.objectData, "pole_effort." + varName);
      } else {
        return _.get(this.objectData, varName);
      }
    },

    updateValue(varName, newValue) {
      if (varName.includes("tp_pe_")) {
        this.$emit("updateValue", {
          varName: "pole_effort." + varName,
          value: newValue
        });
      } else {
        this.$emit("updateValue", {
          varName: varName,
          value: newValue
        });
      }
    }
  }
};



// WEBPACK FOOTER //
// ./src/mixins/forms/poleEffortTabsMixin.js